module.exports = __webpack_public_path__ + "static/img/5.92dde4d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/companyLogo-f/5.jpg
// module id = rqxG
// module chunks = 0